export const environment = {
  apiUrl: 'https://api.showlogger.com/api/v1',
  fileUrl: 'https://api.showlogger.com/api/v1/files',
  appEnvironment: 'prod',
  appVersion: '2.24.8',
  production: true,
  appName: 'Showlogger',
  iosAppBundleId: 'com.softalist.carologboek',
  androidAppBundleId: 'com.softalist.carologboek',
  build: '1773840659',
  enableSentry: true,
  sentryDsn: 'https://ed5565928717fddb870ae24af88b10d9@o4505273847054336.ingest.sentry.io/4505976057364480'
};
